module.exports = __webpack_public_path__ + "static/media/exclusive-offers.fc397648.png";